export const BACKSPACE = 8;
export const SUPR = 46;
export const ALT = 18;
export const SPACE = 32;
export const LEFT_ARROW = 37;
export const RIGHT_ARROW = 39;
export const TOP_ARROW = 38;
export const DOWN_ARROW = 40;
export const ALPHA_DOT = 190;
export const NUMERIC_DOT = 110;
export const ALPHA_NUMBER_0 = 48;
export const ALPHA_NUMBER_1 = 49;
export const ALPHA_NUMBER_2 = 50;
export const ALPHA_NUMBER_3 = 51;
export const ALPHA_NUMBER_4 = 52;
export const ALPHA_NUMBER_5 = 53;
export const ALPHA_NUMBER_6 = 54;
export const ALPHA_NUMBER_7 = 55;
export const ALPHA_NUMBER_8 = 56;
export const ALPHA_NUMBER_9 = 57;
export const NUMERIC_NUMBER_0 = 96;
export const NUMERIC_NUMBER_1 = 97;
export const NUMERIC_NUMBER_2 = 98;
export const NUMERIC_NUMBER_3 = 99;
export const NUMERIC_NUMBER_4 = 100;
export const NUMERIC_NUMBER_5 = 101;
export const NUMERIC_NUMBER_6 = 102;
export const NUMERIC_NUMBER_7 = 103;
export const NUMERIC_NUMBER_8 = 104;
export const NUMERIC_NUMBER_9 = 105;
export const NUMERIC_SUBSTRACT = 109;
export const ALPHA_SUBSTRACT = 189;
export const SHIFT = 9;
export const CTRL = 17;

export const INPUT_NAVIGATION_ARROWS = [LEFT_ARROW, RIGHT_ARROW, TOP_ARROW, DOWN_ARROW];

export const INPUT_NAVIGATION_AND_ERASE_ARROWS = [
    ...INPUT_NAVIGATION_ARROWS,
    BACKSPACE,
    SUPR,
    SHIFT,
    CTRL,
];

export const NATURAL_NUMERIC_KEYCODES = [
    ALPHA_NUMBER_0,
    ALPHA_NUMBER_1,
    ALPHA_NUMBER_2,
    ALPHA_NUMBER_3,
    ALPHA_NUMBER_4,
    ALPHA_NUMBER_5,
    ALPHA_NUMBER_6,
    ALPHA_NUMBER_7,
    ALPHA_NUMBER_8,
    ALPHA_NUMBER_9,
    NUMERIC_NUMBER_0,
    NUMERIC_NUMBER_1,
    NUMERIC_NUMBER_2,
    NUMERIC_NUMBER_3,
    NUMERIC_NUMBER_4,
    NUMERIC_NUMBER_5,
    NUMERIC_NUMBER_6,
    NUMERIC_NUMBER_7,
    NUMERIC_NUMBER_8,
    NUMERIC_NUMBER_9,
    ...INPUT_NAVIGATION_AND_ERASE_ARROWS,
];

export const POSITIVE_NUMERIC_KEYCODES = [
    ...NATURAL_NUMERIC_KEYCODES,
    ALPHA_DOT,
    NUMERIC_DOT,
];

export const INPUT_NATURAL_NUMERIC_KEYCODES = [
    ...NATURAL_NUMERIC_KEYCODES,
    ...INPUT_NAVIGATION_AND_ERASE_ARROWS,
    SHIFT,
];

export const INPUT_NUMERIC_KEYCODES = [
    ...POSITIVE_NUMERIC_KEYCODES,
    ...INPUT_NAVIGATION_AND_ERASE_ARROWS,
    SHIFT,
];
